// GoalStat: Kennzahl mit Tagesziel („12 / 60“) und Fortschrittsbalken; ohne Ziel nur die Zahl. Mit previous zeigt sie
// den Trend zum letzten Anruftag bis zur gleichen Uhrzeit („▲ 3 mehr als gestern“).
export function GoalStat({
  value,
  target,
  label,
  previous,
  previousLabel = 'gestern',
}: {
  value: number;
  target?: number;
  label: string;
  previous?: number;
  previousLabel?: string;
}) {
  const pct = target ? Math.min(100, Math.round((value / target) * 100)) : 0;
  const reached = !!target && value >= target;
  const diff = previous === undefined ? 0 : value - previous;
  const trend =
    previous === undefined
      ? null
      : diff > 0
        ? { cls: 'up', text: `▲ ${diff} mehr als ${previousLabel}` }
        : diff < 0
          ? { cls: 'down', text: `▼ ${-diff} weniger als ${previousLabel}` }
          : { cls: 'same', text: `wie ${previousLabel}` };
  return (
    <li className={reached ? 'stat stat-card goal-stat goal-reached' : 'stat stat-card goal-stat'}>
      <span className="stat-value">
        {value}
        {target ? <small className="goal-target"> / {target}</small> : null}
      </span>
      <span className="stat-label">
        {label}
        {reached ? ' · Ziel erreicht' : ''}
      </span>
      {target ? (
        <span className="goal-bar" role="progressbar" aria-label={`${label}: ${value} von ${target}`} aria-valuemin={0} aria-valuemax={target} aria-valuenow={Math.min(value, target)}>
          <span style={{ width: `${pct}%` }} />
        </span>
      ) : null}
      {trend && <span className={`stat-trend stat-trend-${trend.cls}`}>{trend.text}</span>}
    </li>
  );
}
